export default "__VITE_ASSET__DckiaOiF__"